import React from 'react'

import format from '@st-operations/uikit/lib/format'

const ICONS = {
  Smartphone: (
    <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.0001 24.99V7.00998L8 7L8.0001 6.99002V5C8.0001 3.61929 9.11939 2.5 10.5001 2.5H22.5001C23.8808 2.5 25.0001 3.61929 25.0001 5V27C25.0001 28.3807 23.8808 29.5 22.5001 29.5H10.5001C9.11939 29.5 8.0001 28.3807 8.0001 27V25.01C8.00003 25.0067 8 25.0033 8 25C8 24.9967 8.00003 24.9933 8.0001 24.99ZM10.5001 3.5C9.67167 3.5 9.0001 4.17157 9.0001 5V6.5H24.0001V5C24.0001 4.17157 23.3285 3.5 22.5001 3.5H10.5001ZM9.0001 25.5V27C9.0001 27.8284 9.67167 28.5 10.5001 28.5H22.5001C23.3285 28.5 24.0001 27.8284 24.0001 27V25.5H9.0001ZM24.0001 24.5H9.0001V7.5H24.0001V24.5Z"
        fill="#1F1F1F"
      />
    </svg>
  ),
  'Personal Computer': (
    <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 24.5H26.5C27.8807 24.5 29 23.3807 29 22V19.0014L29 19L29 18.9986V8C29 6.61929 27.8807 5.5 26.5 5.5H6.5C5.11929 5.5 4 6.61929 4 8V22C4 23.3807 5.11929 24.5 6.5 24.5H16V27.5H12.5C12.2239 27.5 12 27.7239 12 28C12 28.2761 12.2239 28.5 12.5 28.5H20.5C20.7761 28.5 21 28.2761 21 28C21 27.7239 20.7761 27.5 20.5 27.5H17V24.5ZM28 22C28 22.8284 27.3284 23.5 26.5 23.5H6.5C5.67157 23.5 5 22.8284 5 22V19.5H28V22ZM5 8V18.5H28V8C28 7.17157 27.3284 6.5 26.5 6.5L6.5 6.5C5.67157 6.5 5 7.17157 5 8Z"
        fill="#1F1F1F"
      />
    </svg>
  ),
  Tablet: (
    <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27 24.0014V26C27 27.3807 25.8807 28.5 24.5 28.5H8.5C7.11929 28.5 6 27.3807 6 26V6C6 4.61929 7.11929 3.5 8.5 3.5H24.5C25.8807 3.5 27 4.61929 27 6V7.9986L27 8L27 8.0014V23.9986L27 24L27 24.0014ZM26 6C26 5.17157 25.3284 4.5 24.5 4.5H8.5C7.67157 4.5 7 5.17157 7 6V7.5H26V6ZM7 23.5V8.5H26V23.5H7ZM7 24.5V26C7 26.8284 7.67157 27.5 8.5 27.5H24.5C25.3284 27.5 26 26.8284 26 26V24.5H7Z"
        fill="#1F1F1F"
      />
    </svg>
  ),
  Other: (
    <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.5 24.5C27.8807 24.5 29 23.3807 29 22V8C29 6.61929 27.8807 5.5 26.5 5.5H6.5C5.11929 5.5 4 6.61929 4 8V22C4 23.3807 5.11929 24.5 6.5 24.5H26.5ZM28 22C28 22.8284 27.3284 23.5 26.5 23.5H6.5C5.67157 23.5 5 22.8284 5 22V8C5 7.17157 5.67157 6.5 6.5 6.5L26.5 6.5C27.3284 6.5 28 7.17157 28 8V22Z"
        fill="#1F1F1F"
      />
      <path
        d="M12.5 27.5C12.2239 27.5 12 27.7239 12 28C12 28.2761 12.2239 28.5 12.5 28.5H20.5C20.7761 28.5 21 28.2761 21 28C21 27.7239 20.7761 27.5 20.5 27.5H12.5Z"
        fill="#1F1F1F"
      />
    </svg>
  ),
}

const NOT_GROUPED_TYPES = ['Smartphone', 'Personal Computer', 'Tablet']

const DeviceTypes = ({ types }) => {
  const normalizedTypes = types.reduce((acc, cur) => {
    if (NOT_GROUPED_TYPES.includes(cur.deviceType)) {
      return [...acc, cur]
    }

    const other = acc.find((type) => type.deviceType === 'Other')

    if (other) {
      other.percentage = other.percentage + cur.percentage
      other.size = other.size + cur.size
      return acc
    }

    return [...acc, { ...cur, deviceType: 'Other' }]
  }, [])

  return (
    <div className="domain-details-modal__devices__container">
      <div className="domain-details-modal__devices__types">
        <For each="type" index="index" of={normalizedTypes}>
          <div key={type.deviceType} className="domain-details-modal__devices__type">
            {ICONS[type.deviceType]}
            <p className="domain-details-modal__devices__legend" key={`device-type-text-${index}`}>
              <span className="domain-details-modal__devices__percentage">{`${Math.round(
                (type.percentage || type.percent) * 100
              )}%`}</span>
              <span className="domain-details-modal__devices__text">{type.deviceType}</span>
              <If condition={type.users}>
                <span className="domain-details-modal__devices__users">
                  {format('metric', type.users)} users
                </span>
              </If>
            </p>
          </div>
        </For>
      </div>
    </div>
  )
}

export default DeviceTypes
